.scrollbar {
    opacity: 0.4;
}

.bubble {
    font-size: var(--mantine-font-size-sm);
    line-height: var(--mantine-spacing-lg); /* 125%ish */
    width: fit-content;

    border-radius: var(--mantine-spacing-md);
    text-align: start;
    white-space: pre-wrap;
    word-break: break-word;
    --mantine-color-anchor: var(--mantine-color-success-3);

    /* Dark mode (default): expert darker than customer */
    background-color: var(--mantine-color-dark-5);
    color: var(--mantine-color-text);
    transition: background-color 0.2s ease;

    &:hover {
        background-color: var(--mantine-color-dark-6);
    }

    &[data-sender-type="customer"] {
        background-color: var(--mantine-color-dark-4);
        color: var(--mantine-color-text);

        &:hover {
            background-color: var(--mantine-color-dark-5);
        }
    }

    &[data-flex-align="flex-start"] {
        border-top-left-radius: var(--mantine-spacing-3xs);
        &[data-last-of-group="false"] {
            border-bottom-left-radius: var(--mantine-spacing-3xs);
        }
    }

    &[data-flex-align="flex-end"] {
        border-top-right-radius: var(--mantine-spacing-3xs);
        &[data-last-of-group="false"] {
            border-bottom-right-radius: var(--mantine-spacing-3xs);
        }
    }

    > ::selection {
        color: var(--mantine-color-black);
        background-color: var(--mantine-color-success-4);
    }

    a:visited,
    a:hover,
    a:active {
        --mantine-color-anchor: var(--mantine-color-success-2);
    }

    max-width: 80%;

    @media (max-width: $mantine-breakpoint-lg) {
        max-width: 90%;
    }

    @media (max-width: $mantine-breakpoint-md) {
        max-width: 95%;
    }
}

/* Light mode: expert a shade darker than customer */
[data-mantine-color-scheme="light"] .bubble {
    background-color: var(--mantine-color-gray-3);

    &:hover {
        background-color: var(--mantine-color-gray-4);
    }

    &[data-sender-type="customer"] {
        background-color: var(--mantine-color-gray-1);

        &:hover {
            background-color: var(--mantine-color-gray-2);
        }
    }
}

.contentWrapper {
    position: relative;
}

.messageContent {
    max-width: 100%;
    word-wrap: break-word;
    padding: var(--mantine-spacing-md);
    position: relative;
    align-items: flex-end;

    &[data-has-receipt="true"] {
        padding-right: var(--mantine-spacing-xxl); /* Extra space for receipt icon */
    }
}

.textContent {
    display: inline;
    user-select: text;
    font: inherit;
    flex-grow: 1;
}

.receiptIcon {
    position: absolute;
    bottom: var(--mantine-spacing-xxs);
    right: var(--mantine-spacing-xxs);
}

.dividerLabel {
    color: var(--mantine-color-dark-3);

    /* these override the default divider styles for mantine so we can have a fade and the size prop still works! */
    &:before {
        border-top: none;
        height: var(--divider-size);
        background: linear-gradient(to left, var(--mantine-color-dark-4), transparent);
    }
    &:after {
        border-top: none;
        height: var(--divider-size);
        background: linear-gradient(to right, var(--mantine-color-dark-4), transparent);
    }
}

.new_message_button {
    padding-left: var(--mantine-spacing-lg);
    padding-right: var(--mantine-spacing-lg);
    border: 2px solid var(--mantine-color-primary-6);
    animation: fadeIn 0.3s ease-in 1;
}

.new_message_button_label {
    margin-right: var(--mantine-spacing-4xs);
    margin-left: var(--mantine-spacing-4xs);
}

.new_message_button_section {
    /* Apply styles only to left section */

    &[data-position="left"] {
        --section-size: calc(var(--button-height) - var(--mantine-spacing-lg));

        background-color: var(--mantine-color-primary-6);
        color: var(--mantine-color-text);
        height: var(--section-size);
        width: var(--section-size);
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
    }
}

.customer_typing_indicator {
    color: var(--mantine-color-gray-6);
    opacity: 0.9;
}

.typing_ellipsis span {
    opacity: 0;
    animation: typingDot 1.5s infinite;
    margin-left: 1px;
}

.typing_ellipsis .dot2 {
    animation-delay: 0.3s;
}

.typing_ellipsis .dot3 {
    animation-delay: 0.6s;
}

@keyframes typingDot {
    0% {
        opacity: 0;
    }
    30% {
        opacity: 1;
    }
    60% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}

@keyframes fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
